import * as React from "react";
import { TitleText, ToastMain, ToastWrapper, ToastMessage, CloseBtn, OKBtn, SuccessIcon, Toast, } from "./styles";
import { getLitbLangFn } from "../../utils/language";
export const IOSNOLOGINSTATUS = 6;
const SUCCESSIMG = "https://i.ezbuy.sg/FkieMxPmvO_9sJZXgjW_RbFPuhDq";
const CloseImg = "https://i.ezbuy.sg/FhYcSLDzkvBNtq4pts-5qsidTRfG";
export const getTextByStatus = (status, lang = "en") => {
    switch (status) {
        case 1:
            return `${getLitbLangFn("Awesome Coupons are at your fingertips!", lang)}`;
            break;
        case 2:
            return `${getLitbLangFn("These Coupons have run out. <br/>Check back soon! More surprises waiting for you everyday!", lang)}`;
            break;
        case 3:
            return `${getLitbLangFn("You have already got these Coupons. <br/>Please come back tomorrow.", lang)}`;
            break;
        case 4:
            return `${getLitbLangFn('Check your <a href="%s">Coupons</a> account now.', lang)}`.replace(`href="%s"`, "");
            break;
        case IOSNOLOGINSTATUS:
            return "Please go to the login page to log in, and then come here to get coupon";
            break;
        default:
            return `${getLitbLangFn('Check your <a href="%s">Coupons</a> account now.', lang)}`.replace(`href="%s"`, "");
    }
};
export const LTReceiveToast = (props) => {
    const { isMobile = false, onClose, status = -1, lang = "en" } = props;
    return (React.createElement(ToastWrapper, { isMobile: isMobile },
        React.createElement(Toast, { isMobile: isMobile },
            React.createElement(CloseBtn, { isMobile: isMobile },
                React.createElement("img", { src: CloseImg, onClick: onClose })),
            React.createElement(ToastMain, null,
                status === 4 && (React.createElement(React.Fragment, null,
                    React.createElement(SuccessIcon, { isMobile: isMobile },
                        React.createElement("img", { src: SUCCESSIMG })),
                    React.createElement(TitleText, null, `${getLitbLangFn("Received successfully", lang)}`))),
                React.createElement(ToastMessage, { style: { paddingTop: status !== 4 ? "12px" : "" }, dangerouslySetInnerHTML: {
                        __html: getTextByStatus(status, lang),
                    } }),
                React.createElement(OKBtn, { isMobile: isMobile },
                    React.createElement("p", { onClick: onClose }, `${getLitbLangFn("OK", lang)}`))))));
};
